import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import rightArrow from '../../images/arrow-right-blue-textlink.svg';
import '../../sass/components/flexibleModules/_components.genericAwardsBannerComponent.scss';

const GenericAwardsBannerComponent = ({ data }) => {
    return (
        <div className={`cp-awardsBannerComponent ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundColor}` }}> 
            <div className="cp-awardsBannerComponent__inner l--flex" style={{ backgroundColor: `${data.genericAwardsBannerBackground}`, maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                <div className="cp-awardsBannerComponent__left">
                    {data.genericAwardsBannerHeader &&
                        <h2 dangerouslySetInnerHTML={{__html: data.genericAwardsBannerHeader}} />
                    }
                    {data.genericAwardsBannerTeaser &&
                        <p dangerouslySetInnerHTML={{__html: data.genericAwardsBannerTeaser}} />
                    }
                    {data.genericAwardsBannerLink &&
                        <a href={data.genericAwardsBannerLink.url} target={data.genericAwardsBannerLink.target} className="l-textlink">
                            <span>{data.genericAwardsBannerLink.title}</span>
                            <img src={rightArrow} alt="" />
                        </a>
                    }
                </div>
                <div className="cp-awardsBannerComponent__right">
                    {data.genericAwardsBannerImage &&
                        <GatsbyImage image={getImage(data.genericAwardsBannerImage.gatsbyImage)} alt={data.genericAwardsBannerImage.altText} />
                    }
                </div>
            </div>
        </div>
    );
}

export default GenericAwardsBannerComponent;